<ng-container *ngIf="block.styles.format !== 'button'">
  <div class="block-wrapper"
       [ngClass]="{'isFile': block.settings.name}">
    <app-file-picker *ngIf="blocksConfig.uploadable; else attachmentTemplate"
                     [file]="block.file?.default_url || this.block.settings.name"
                     (fileChange)="onFile($event)"
                     appearance="area"
                     [clickDisabled]="!blockComponent?.selected">

      <pl-icon class="icon ml-3 ml-sm-0" icon="builderAttachment"></pl-icon>
      <pl-icon class="icon-overlay ml-3 ml-sm-0" icon="builderAttachment"></pl-icon>

      <ng-container *ngTemplateOutlet="attachmentTemplate"></ng-container>
    </app-file-picker>
  </div>

  <ng-template #attachmentTemplate>
    <ng-container *transloco="let t; read: 'blocks.' + block.type + '.settings.upload'">
      <div class="d-flex flex-wrap flex-md-nowrap align-items-center justify-content-between p-2" *ngIf="block.settings.name">
        <div class="d-flex align-items-center p-2 mr-2">
          <pl-icon class="paperclip" icon="builderAttachmentVertical"></pl-icon>
          <div class="title">
            <p class="label">
              {{block.settings.label || block.settings.name}}
            </p>
            <p class="info mb-0">
              <span>{{(uploadingBlob?.byte_size || block?.file?.byte_size || block.settings.size) | fileSize:0 }}</span>
              <span *ngIf="uploadingBlob?.uploadPercentage > 0 && uploadingBlob.uploadPercentage < 100"> - <app-loading-spinner></app-loading-spinner>
                {{uploadingBlob.uploadPercentage | number:'1.0-0'}}%</span>
            </p>
          </div>
        </div>

        <div class="d-flex p-2" *ngIf="!!block.file && !!block.file.default_url">
          <a *ngIf="block.settings.view_enabled && block.file.url"
             [href]="block.file.url"
             [style.background-color]="block.styles.button_background"
             [style.color]="block.styles.button_color"
             (click)="trackDownload()"
             class="btn btn-light mr-2 view-button d-print-none"
             target="_blank">
            {{t('view_button')}}
          </a>
          <a *ngIf="block.file.url"
             [href]="block.file.attachmentUrl"
             [style.background-color]="block.styles.button_background"
             [style.color]="block.styles.button_color"
             (click)="trackDownload()"
             class="btn btn-light download-button"
             download>
            <pl-icon class="d-block"
                     [ngClass]="{'viewEnabled': block.settings.view_enabled}"
                     icon="builderDownload">
            </pl-icon>
            <span class="d-none d-sm-block ml-sm-2" *ngIf="!block.settings.view_enabled">
              {{t('download_button')}}
            </span>
          </a>
        </div>
      </div>
    </ng-container>
  </ng-template>
</ng-container>
<app-button *ngIf="block.styles.format === 'button'"
            (clickHandler)="onDownload()"
            [block]="legacyFakeButton"
            [customClickHandler]="true"></app-button>
